export const LEGAL_DOCUMENT_VIEWER_CLOSE_LABEL = 'Fechar';
export const LEGAL_DOCUMENT_VIEWER_OVERLAY_CLOSE_ARIA = 'Fechar documento';

export const LEGAL_DOCUMENT_VIEWER_MODAL_TITLE_TERMS = 'Termos de Uso';

export const LEGAL_DOCUMENT_VIEWER_MODAL_TITLE_PRIVACY = 'Política de Privacidade';
